var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCareer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6666 33.3333C14.3655 33.3333 12.5 35.1988 12.5 37.5V79.1667C12.5 81.4679 14.3655 83.3333 16.6666 83.3333H83.3333C85.6345 83.3333 87.5 81.4679 87.5 79.1667V37.5C87.5 35.1988 85.6345 33.3333 83.3333 33.3333H16.6666ZM4.16663 37.5C4.16663 30.5965 9.76308 25 16.6666 25H83.3333C90.237 25 95.8333 30.5965 95.8333 37.5V79.1667C95.8333 86.0704 90.237 91.6667 83.3333 91.6667H16.6666C9.76308 91.6667 4.16663 86.0704 4.16663 79.1667V37.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8278 11.9945C35.172 9.65029 38.3514 8.33333 41.6666 8.33333H58.3333C61.6483 8.33333 64.8279 9.65029 67.172 11.9945C69.5162 14.3387 70.8333 17.5181 70.8333 20.8333V87.5C70.8333 89.8013 68.9679 91.6667 66.6666 91.6667C64.3654 91.6667 62.5 89.8013 62.5 87.5V20.8333C62.5 19.7282 62.0608 18.6685 61.2795 17.887C60.4983 17.1057 59.4383 16.6667 58.3333 16.6667H41.6666C40.5615 16.6667 39.5017 17.1057 38.7203 17.887C37.939 18.6685 37.5 19.7282 37.5 20.8333V87.5C37.5 89.8013 35.6345 91.6667 33.3333 91.6667C31.0321 91.6667 29.1666 89.8013 29.1666 87.5V20.8333C29.1666 17.5181 30.4836 14.3387 32.8278 11.9945Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.ddbd5b0ffe15199533a2000e74bbbf27.svg";
export { ForwardRef as ReactComponent };